import { render, staticRenderFns } from "./channelDetail.vue?vue&type=template&id=4d359d6a&scoped=true&"
import script from "./channelDetail.vue?vue&type=script&lang=js&"
export * from "./channelDetail.vue?vue&type=script&lang=js&"
import style0 from "./channelDetail.vue?vue&type=style&index=0&id=4d359d6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d359d6a",
  null
  
)

export default component.exports